import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import NotificationPopupApi from '../../Api/NotificationPopup';
import { Icon } from '@iconify/react/dist/iconify.js';
import SearchableDropdown from './SearchableDropdown';
import Swal from "sweetalert2";
import SearchableMultiDropdown from './SearchableMultiDropdown';
import Branches from '../../Api/Branches';

const NotificationPopup = () => {

    const [data, setData] = useState([]);
    const [notificationId, setNotificationId] = useState(null);
    const [title, setTitle] = useState('');
    const [textMessage, setTextMessage] = useState('');
    const [branchData, setBranchData] = useState([]);
    const [inputValues, setInputValues] = useState({
        branchId: []
    });
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    useEffect(() => {
        const now = new Date();
        const currentDate = now.toISOString().split('T')[0];
        const currentTime = now.toTimeString().slice(0, 5);

        setFromDate(currentDate);
        setToDate(currentDate);
        setStartTime(currentTime);
        setEndTime(currentTime);
    }, []);

    const fetchBranchData = async () => {
        const response = await Branches.GetAllClients(1, 10000)
        if (response) {
            console.log("response", response);
            setBranchData(response.Result)
        }
    }
    useEffect(() => {
        fetchBranchData()
    }, []);

    function formatIsoDate(isoDate) {
        if (typeof isoDate !== 'string' || !isoDate) return '';
        const datePart = isoDate.substring(0, 10);
        const [year, month, day] = datePart.split('-');
        return `${day}-${month}-${year}`;
    }

    function toInputDate(dateStr) {
        if (!dateStr) return '';
        if (dateStr.includes('T')) return dateStr.substring(0, 10);
        const [d, m, y] = dateStr.split('-');
        return `${y}-${m}-${d}`;
    }

    const clearForm = () => {
        setNotificationId(null);
        setTitle('');
        setTextMessage('');

        const now = new Date();
        const currentDate = now.toISOString().split('T')[0];
        const currentTime = now.toTimeString().slice(0, 5);

        setFromDate(currentDate);
        setToDate(currentDate);
        setStartTime(currentTime);
        setEndTime(currentTime);
        setInputValues({
            branchId: []
        })
    };

    const handleSave = async () => {
        const payload = { title, textMessage, fromDate, toDate, startTime, endTime, branch: (inputValues.branchId || []).join(",") };
        const response = await NotificationPopupApi.create(payload);
        if (response) {
            Swal.fire({ title: "Saved", text: "Notification saved successfully.", icon: "success", width: "320px" });
            clearForm();
            fetchData();
        }
    };

    function convertDate(dateStr) {
        const [dd, mm, yyyy] = dateStr.split('-');
        return `${yyyy}-${mm}-${dd}`;
    }

    const handleUpdate = async () => {

        const fromDateFormat = convertDate(fromDate);
        const toDateFormat = convertDate(toDate);
        const payload = { title, textMessage, fromDate, toDate, startTime, endTime, branch: (inputValues.branchId || []).join(",") };
        const response = await NotificationPopupApi.UpdateNotification(notificationId, payload);
        if (response) {
            Swal.fire({ title: "Updated", text: "Notification updated successfully.", icon: "success", width: "320px" });
            clearForm();
            fetchData();
        }
    };

    const handleEdit = (item) => {
        setNotificationId(item.id);
        setTitle(item.title);
        setTextMessage(item.textMessage);
        setFromDate((item.fromDate));
        setToDate((item.toDate));
        setStartTime(item.startTime);
        setEndTime(item.endTime);
        setInputValues({
            branchId: item.branch
                ? item.branch.split(",").map(x => Number(x))
                : []
        });
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this record?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;
        const response = await NotificationPopupApi.DeleteNotification(id);
        if (response) {
            Swal.fire({ title: "Deleted", text: "Deleted Successfully.", icon: "success", width: "320px" });
            fetchData();
        }
    };

    const fetchData = async () => {
        const response = await NotificationPopupApi.getAll();
        if (response) {
            setData(response.Result);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Notification Info</h2>
                </div>
                <div className="control_radius">

                    {/* ── Input Fields ── */}
                    <div className='control_radius'>
                        <div className='company_control'>
                            <div className="stock-im-dep1">
                                <div className="input-box-Imo1 input-height2">
                                    <div className="input-box-mok1">
                                        <input
                                            className="modify_im_input mode_category1"
                                            type="text"
                                            value={title}
                                            required
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                        <label className="modify_p_text2">Title</label>
                                    </div>
                                </div>
                            </div>
                            <div className="stock-im-dep1">
                                <div className="input-box-Imo1 input-height2">
                                    <div className="input-box-mok1">
                                        <textarea
                                            className="modify_im_input mode_category1"
                                            name="TextMessage"
                                            value={textMessage}
                                            onChange={(e) => setTextMessage(e.target.value)}
                                            rows={2}
                                        />
                                        <label className="modify_p_text2">Text Message</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='company_control'>
                            <div className="stock-im-dep1">
                                <div className="input-box-Imo1 input-height2">
                                    <div className="input-box-mok1">
                                        <input
                                            className="modify_im_input mode_category1"
                                            type="date"
                                            value={(fromDate)}
                                            required
                                            onChange={(e) => setFromDate(e.target.value)}
                                        />
                                        <label className="modify_p_text2">From Date</label>
                                    </div>
                                </div>
                            </div>
                            <div className="stock-im-dep1">
                                <div className="input-box-Imo1 input-height2">
                                    <div className="input-box-mok1">
                                        <input
                                            className="modify_im_input mode_category1"
                                            type="date"
                                            value={(toDate)}
                                            required
                                            onChange={(e) => setToDate(e.target.value)}
                                        />
                                        <label className="modify_p_text2">To Date</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='company_control'>
                            <div className="stock-im-dep1">
                                <div className="input-box-Imo1 input-height2">
                                    <div className="input-box-mok1">
                                        <input
                                            className="modify_im_input mode_category1"
                                            type="time"
                                            value={startTime}
                                            required
                                            onChange={(e) => setStartTime(e.target.value)}
                                        />
                                        <label className="modify_p_text2">Start Time</label>
                                    </div>
                                </div>
                            </div>
                            <div className="stock-im-dep1">
                                <div className="input-box-Imo1 input-height2">
                                    <div className="input-box-mok1">
                                        <input
                                            className="modify_im_input mode_category1"
                                            type="time"
                                            value={endTime}
                                            required
                                            onChange={(e) => setEndTime(e.target.value)}
                                        />
                                        <label className="modify_p_text2">End Time</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='company_control'>
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <SearchableMultiDropdown
                                        options={branchData}
                                        value={inputValues.branchId}
                                        onChange={(ids) =>
                                            setInputValues({ ...inputValues, branchId: ids })
                                        }
                                        labelField="branchName"
                                        valueField="id"
                                        placeholder="Select Branch"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Save / Update Button ── */}
                    <div className="ButtonTabSave">
                        {notificationId ? (
                            <button
                                id="SaveBtnMain"
                                className="update-button-main-save hovered"
                                onClick={handleUpdate}
                            >
                                Update
                            </button>
                        ) : (
                            <button
                                id="SaveBtnMain"
                                className="save-button-main-save hovered"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}
                    </div>

                    {/* ── Table ── */}
                    <div className="company_info-text-im depart_top">Notification List</div>
                    <div className="control_radius">
                        <div className="table-account-manager">
                            <table className='table-master-acc'>
                                <thead className='header-table-account'>
                                    <tr>
                                        <th className='table-header-manager ac-sno-wth'>S.No</th>
                                        <th className='table-header-manager'>Title</th>
                                        <th className='table-header-manager'>Text Message</th>
                                        <th className='table-header-manager'>From Date</th>
                                        <th className='table-header-manager'>To Date</th>
                                        <th className='table-header-manager'>Start Time</th>
                                        <th className='table-header-manager'>End Time</th>
                                        <th className='table-header-manager'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data
                                        .slice().reverse()
                                        .map((item, idx) => (
                                            <tr key={item.id}>
                                                <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                                <td className='table-data-account'>{item.title}</td>
                                                <td
                                                    className="table-data-account"
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "500px",
                                                    }}
                                                >
                                                    {item.textMessage}
                                                </td>
                                                <td className='table-data-account'>{formatIsoDate(item.fromDate)}</td>
                                                <td className='table-data-account'>{formatIsoDate(item.toDate)}</td>
                                                <td className='table-data-account'>{item.startTime}</td>
                                                <td className='table-data-account'>{item.endTime}</td>
                                                <td className='table-data-account'>
                                                    <button className="edit-btn-acc" onClick={() => handleEdit(item)}>
                                                        <Icon icon="lucide:edit" />
                                                    </button>
                                                    <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}>
                                                        <Icon icon="material-symbols:delete" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;